<template>
  <div>
    <div class="contact-form">
      <div class="columns">
        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="form-group">
            <input
              v-model="userData.name"
              class="form-input rounded text-center focus-purple"
              type="text"
              v-bind:placeholder="this.getCaption('caption.your_name')"
              v-on:input="onChangeHandler('name', $v.userData.name)"
              :class="{ 'form-control is-invalid is-error': $v.userData.name.$error }"
            >
            <div v-if="!$v.userData.name.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('name')[0] }}</span>
            </div>
          </div>
        </div>
        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="form-group">
            <input
              v-model="userData.phone"
              class="form-input rounded text-center focus-purple"
              type="text"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              maxlength="8"
              v-bind:placeholder="this.getCaption('caption.phone')"
              v-on:input="onChangeHandler('phone', $v.userData.phone)"
              :class="{ 'form-control is-invalid is-error': $v.userData.phone.$error }"
            >
            <div v-if="!$v.userData.phone.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('phone')[0] }}</span>
            </div>
          </div>
        </div>
        <div class="column col-12 mt-5"></div>

        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="form-group">
            <input
              v-model="userData.email"
              class="form-input rounded text-center focus-purple"
              type="text"
              v-bind:placeholder="this.getCaption('caption.email')"
              v-on:input="onChangeHandler('email', $v.userData.email)"
              :class="{ 'form-control is-invalid is-error': $v.userData.email.$error }"
            >
            <div v-if="!$v.userData.email.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('email')[0] }}</span>
            </div>
          </div>
        </div>

        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="captch-example">
            <img id="captcha" src>
            <button class="btn btn--color-purple rounded" @click="getCaptcha()">
              <i class="fas fa-sync-alt"></i>
            </button>
          </div>
        </div>

        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="form-group">
            <input
              v-model="userData.captcha"
              class="form-input rounded text-center focus-purple"
              type="text"
              v-bind:placeholder="this.getCaption('caption.insert_above_code')"
              v-on:input="onChangeHandler('captcha', $v.userData.captcha)"
              :class="{ 'form-control is-invalid is-error': $v.userData.captcha.$error }"
            >
            <div v-if="!$v.userData.captcha.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('captcha')[0] }}</span>
            </div>
          </div>
        </div>
        <div class="column col-sm-12 col-7 col-mx-auto">
          <div class="form-group text_container">
            <textarea
              v-model="userData.body"
              class="form-input rounded focus-purple"
              v-bind:placeholder="this.getCaption('caption.write_feedback')"
              v-on:input="onChangeHandler('body', $v.userData.body)"
              :class="{ 'form-control is-invalid is-error': $v.userData.body.$error }"
              rows="3"
            ></textarea>
            <div v-if="!$v.userData.body.serverFailed">
              <span class="error-msg__data">{{ this.getErrorMsg('body')[0] }}</span>
            </div>
          </div>
        </div>
        <div class="column col-sm-12 col-7 col-mx-auto button-container">
          <button @click="onSubmit" class="btn btn--color-orange btn--width-full rounded">
            <div v-if="submitStatus === 'PENDING'" class="loader--sm"></div>
            <span v-else>{{ this.getCaption("caption.send_button") }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autosize from "autosize";
import CaptchaService from "@/services/CaptchaService.js";
import PageService from "@/services/PageService.js";
import Form from "@/mixins/Form.js";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [Form],

  data() {
    return {
      userData: {
        name: "",
        phone: "",
        email: "",
        captcha: null,
        body: null
      }
    };
  },

  mounted() {
    this.getUserData();
    this.getCaptcha();
    autosize(document.querySelectorAll("textarea"));
  },

  validations: {
    userData: {
      name: {
        required,
        serverFailed: function() {
          return !this.hasServerError("name");
        }
      },
      phone: {
        required,
        serverFailed: function() {
          return !this.hasServerError("phone");
        }
      },
      email: {
        required,
        serverFailed: function() {
          return !this.hasServerError("email");
        }
      },
      captcha: {
        required,
        serverFailed: function() {
          return !this.hasServerError("captcha");
        }
      },
      body: {
        required,
        serverFailed: function() {
          return !this.hasServerError("body");
        }
      }
    }
  },

  methods: {
    getUserData() {
      let loggedUser = this.$store.state.loggedUser;
      if (loggedUser) {
        this.userData.name = loggedUser.firstName + " " + loggedUser.lastName;
        this.userData.phone = loggedUser.phone;
        this.userData.email = loggedUser.email;
      }
    },

    getCaptcha() {
      CaptchaService.getCaptcha().then(response => {
        let imgSrc = "data:image/png;base64," + response.data;
        $("#captcha").attr("src", imgSrc);
      });
    },

    serverRequest: PageService.createInquiry,

    createJsonData() {
      const data = JSON.parse("{}");
      data.name = this.userData.name;
      data.phone = this.userData.phone;
      data.email = this.userData.email;
      data.captcha = this.userData.captcha;
      data.body = this.userData.body;
      return data;
    },

    successHandler() {
      this.userData.name = "";
      this.userData.phone = "";
      this.userData.email = "";
      this.userData.captcha = null;
      this.userData.body = null;
      this.$v.$reset();
      this.getCaptcha();
    }
  }
};
</script>

<style lang="scss">
.captch-example {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: block;
    margin: 0 1em;
  }
}

.contact-form {
  margin-top: 20px;

  .form-group {
    padding-bottom: 0.4rem;
    margin-bottom: 1em;
  }
}

.text_container.form-group {
  textarea {
    resize: vertical;
    height: 195px;
  }
}

.button-container {
  padding-top: 0.4rem;
  button {
    width: 100%;
  }
}

#captcha {
  border: 1px solid #dedede;
  margin-bottom: 10px;
  padding: 2px;
}

@media (max-width: $breakpoint-md) {
  #captcha {
    width: auto;
  }
}
</style>
